import { useCallback, useState } from 'react';
import confetti from 'canvas-confetti';
import { useIntl } from 'react-intl';

import { SpinToWinGameProps, SpinToWinGame } from './SpinToWinGame';
import { useConfiguration } from '../../../modules/configuration/useConfiguration';
import { RandomLoyaltySegmentAwardType } from '../../../graphql/types.generated';
import { useInfoActionSheet } from '../../../components/modals/InfoActionSheet';
import { messagesSpinToWin } from './messages.spin-to-win';
import { EnvConfiguration } from '../../../modules/configuration/EnvConfiguration';

export type SpinToWinGameControllerProps = {
  sectors: SpinToWinGameProps['sectors'];
  termsAndConditionsLink: SpinToWinGameProps['termsAndConditionsLink'];
  numberOfGamePlays: SpinToWinGameProps['numberOfGamePlays'];
  // onCompleted(): void;
};

export const SpinToWinGameController = ({
  sectors,
  termsAndConditionsLink,
  numberOfGamePlays,
}: SpinToWinGameControllerProps) => {
  const intl = useIntl();
  const { open: openInfoActionSheet } = useInfoActionSheet();
  const pointsStrategy = useConfiguration('loyaltyProgram.pointsStrategy');
  const [isSpinning, setIsSpinning] = useState(false);
  const [winningSectorIndex, setWinningSectorIndex] = useState<number | undefined>();
  const [disablePlayButton, setDisablePlayButton] = useState(false);

  const onPlayClick = useCallback(() => {
    setDisablePlayButton(true);
    setIsSpinning(true);
    setTimeout(() => {
      setIsSpinning(false);
      setWinningSectorIndex(Math.round(Math.random() * sectors.length));
    }, 3000);
  }, [sectors.length]);

  const onSpinningEnd = useCallback(
    (sectorIndex: number) => {
      setDisablePlayButton(false);

      if (
        sectors[sectorIndex].awardType === RandomLoyaltySegmentAwardType.NoAward ||
        sectors[sectorIndex].awardType === RandomLoyaltySegmentAwardType.TryAgain
      ) {
        return;
      }

      confetti({
        startVelocity: 40,
        particleCount: 200,
        ticks: 500,
        angle: 270,
        spread: 180,
        origin: {
          y: -0.5,
          x: 0.5,
        },
      });

      openInfoActionSheet({
        title: intl.formatMessage(messagesSpinToWin['spinToWinGame:win-popup-title']),
        description: intl.formatMessage(messagesSpinToWin['spinToWinGame:win-popup-description'], {
          vendor: EnvConfiguration.marketing.title,
        }),
        actionButtonText: intl.formatMessage(messagesSpinToWin['spinToWinGame:win-popup-button']),
        onActionButtonClick: () => {},
        isServiceLinkEnabled: false,
      });
    },
    [intl, openInfoActionSheet, sectors],
  );

  return (
    <SpinToWinGame
      sectors={sectors}
      termsAndConditionsLink={termsAndConditionsLink}
      numberOfGamePlays={numberOfGamePlays}
      onPlayClick={disablePlayButton ? undefined : onPlayClick}
      onSpinningEnd={onSpinningEnd}
      isSpinning={isSpinning}
      winningSectorIndex={winningSectorIndex}
      pointsStrategy={pointsStrategy}
    />
  );
};
